import Env from "../base/env";
import Channels from "../base/channels";
import axios from "axios";
import gsap from "gsap";

export function EmitCartOpen() {
  Channels.addListener("cart::open", () => {
    Env.$html.classList.add("cart-opened");
  });
}

export function EmitCartClose() {
  Channels.addListener("cart::close", () =>
    Env.$html.classList.remove("cart-opened")
  );
}

export function EmitMiniFragrancesOpen() {
  Channels.addListener("fragrances-gifts::open", () =>
    Env.$html.classList.add("fragrances-gifts-opened")
  );
}

export function EmitMiniFragrances50mlOpen() {
  Channels.addListener("fragrances-gifts-50ml::open", () =>
    Env.$html.classList.add("fragrances-gifts-opened-50ml")
  );
}

export function EmitMiniFragrancesClose() {
  Channels.addListener("fragrances-gifts::close", () =>
    Env.$html.classList.remove("fragrances-gifts-opened")
  );
}

export function EmitMiniFragrances50mlClose() {
  Channels.addListener("fragrances-gifts-50ml::close", () =>
    Env.$html.classList.remove("fragrances-gifts-opened-50ml")
  );
}

export function AddToCart(data, triggerEvent = true) {
  console.log("test2");
  axios
    .post(window.Shopify.routes.root + "cart/add.js", data)
    .then((response) => {
      Channels.emit("cart::render");
      if (triggerEvent) {
        gsap.delayedCall(0.5, () => Channels.emit("cart::open"));
      }
    });
}

export function UpdateCart(data) {
  axios.post(window.Shopify.routes.root + "cart/change.js", data);
}
